const ID = {
  name: 'subscription.filter.id',
  type: 'text',
  name_query: 'id'
}

const CODE = {
  name: 'subscription.filter.code',
  type: 'text',
  name_query: 'code'
}

const BILLING_TYPE = {
  name: 'subscription.filter.billing-type',
  type: 'select',
  select_options: [
    {
      id: 'prepaid',
      text: 'subscription.filter.prepaid'
    },
    {
      id: 'postpaid',
      text: 'subscription.filter.postpaid'
    },
    {
      id: 'exact_day',
      text: 'subscription.filter.exact-day'
    }
  ],
  name_query: 'billing_type'
}

const CUSTOMER_ID = {
  name: 'subscription.filter.customer-id',
  type: 'text',
  name_query: 'customer_id'
}

const PLAN_ID = {
  name: 'subscription.filter.plan-id',
  type: 'text',
  name_query: 'plan_id'
}

const CARD_ID = {
  name: 'subscription.filter.card-id',
  type: 'text',
  name_query: 'card_id'
}

const STATUS = {
  name: 'subscription.filter.status',
  type: 'select',
  select_options: [
    {
      id: 'active',
      text: 'subscription.filter.active'
    },
    {
      id: 'canceled',
      text: 'subscription.filter.canceled'
    },
    {
      id: 'future',
      text: 'subscription.filter.future'
    }
  ],
  name_query: 'status'
}

const CREATION_PERIOD = {
  name: 'subscription.filter.creation-period',
  type: 'select',
  select_options: [
    {
      id: 'specific_date',
      text: 'subscription.filter.period-specific'
    },
    {
      id: 'date_filters',
      text: 'subscription.filter.period-predefined'
    },
    {
      id: 'interval',
      text: 'subscription.filter.period-interval'
    }
  ],
  name_query: 'period_type'
}

const SPECIFIC_DATE = {
  name: 'subscription.filter.specific-date',
  type: 'date',
  name_query: 'specific_date',
  period_type: 'specific_date'
}

const PREDEFINED_DATE = {
  name: 'subscription.filter.predefined-date',
  type: 'select',
  select_options: [
    {
      id: 'Today',
      text: 'subscription.filter.predefined-today'
    },
    {
      id: 'Yesterday',
      text: 'subscription.filter.predefined-yesterday'
    },
    {
      id: 'SevenDays',
      text: 'subscription.filter.predefined-7-days'
    },
    {
      id: 'FifteenDays',
      text: 'subscription.filter.predefined-15-days'
    },
    {
      id: 'OneMonth',
      text: 'subscription.filter.predefined-30-days'
    }
  ],
  name_query: 'date_filters',
  period_type: 'date_filters'
}

const INITIAL_DATE = {
  name: 'subscription.filter.initial-date',
  type: 'date',
  name_query: 'since',
  period_type: 'interval'
}

const FINAL_DATE = {
  name: 'subscription.filter.final-date',
  type: 'date',
  name_query: 'until',
  period_type: 'interval'
}

const FILTER_OPTIONS = [
  ID,
  CODE,
  BILLING_TYPE,
  CUSTOMER_ID,
  PLAN_ID,
  CARD_ID,
  STATUS,
  CREATION_PERIOD,
  SPECIFIC_DATE,
  PREDEFINED_DATE,
  INITIAL_DATE,
  FINAL_DATE
]

export default FILTER_OPTIONS
